export default "__VITE_ASSET__B_BYW9O___"